import React from 'react';
import { Moon, Sun, Globe, Check } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useI18n } from '../i18n/I18nContext';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from './ui/dropdown-menu';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle-button"
      aria-label="Toggle theme"
      className="w-9 h-9 grid place-items-center rounded-lg border border-border hover:border-vj-neon/50 text-foreground transition-all duration-300 hover:-translate-y-0.5"
    >
      {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}

export function LanguageSelector() {
  const { lang, setLang, languages } = useI18n();
  const current = languages.find((l) => l.code === lang) || languages[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-selector"
          className="flex items-center gap-2 px-3 h-9 rounded-lg border border-border hover:border-vj-neon/50 text-foreground text-sm transition-all duration-300 hover:-translate-y-0.5"
        >
          <Globe size={15} />
          <span className="hidden md:inline">{current.label}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-80 overflow-auto">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="flex items-center justify-between gap-4 cursor-pointer"
          >
            <span className="flex items-center gap-2"><span>{l.flag}</span>{l.label}</span>
            {l.code === lang && <Check size={14} className="text-vj-neon" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
